import {
  getOrgType,
  saveOrgTypeAPI,
  deleteOrgTypeAPI,
  getOrgTypeCombo
} from '../../../services/Masters/MatersService';

export const fetchGlobalTypes = async (globalTypeCategoryID, searchQuery, statusID) => {
  try {
    const response = await getOrgType(globalTypeCategoryID, searchQuery, statusID);

    if (response && response.success) {
      return response.returnResult || [];
    } else {
      window.showSnackbar({
        message: response?.message || 'An error occurred while fetching org types',
        variant: 'error'
      });
      console.log('Error fetching org types:', response?.message);
      return [];
    }
  } catch (err) {
    window.showSnackbar({
      message: err.message || 'An error occurred while fetching org types',
      variant: 'error'
    });
    console.log('Error fetching org types:', err);
    return [];
  }
};

export const fetchGlobalTypesCombo = async (globalTypeCategoryID) => {
  try {
    const response = await getOrgTypeCombo(globalTypeCategoryID);

    if (response && response.success) {
      return response.returnResult || [];
    } else {
      window.showSnackbar({
        message: response?.message || 'An error occurred while fetching globaltypes combo',
        variant: 'error'
      });
      console.log('Error fetching globaltypes combo:', response?.message);
      return [];
    }
  } catch (err) {
    window.showSnackbar({
      message: err.message || 'An error occurred while fetching globaltypes combo',
      variant: 'error'
    });
    console.log('Error fetching globaltypes combo:', err);
    return [];
  }
};

export const saveOrgType = async (payload, customSuccessMsg, customErrorMsg) => {
  try {
    const response = await saveOrgTypeAPI(payload);
    if (!response || !response.success) {
      console.log('response?.message', response?.message || 'Failed to save globle type');
      window.showSnackbar({
        message: customErrorMsg || `Failed to save globle type`,
        variant: 'error'
      });
    } else {
      window.showSnackbar({
        message: customSuccessMsg || `globle type saved successfully`,
        variant: 'success'
      });
    }
    return response;
  } catch (err) {
    const errorMessage =
      err?.message || (typeof err === 'string' ? err : 'Failed to save globle type');
    window.showSnackbar({
      message: errorMessage,
      variant: 'error'
    });
    console.log('Failed to save globle type:', err);
    return { success: false, message: errorMessage };
  }
};

export const deleteOrgType = async (
  globalTypeID,
  globalTypeCategoryID,
  customSuccessMsg,
  customErrorMsg
) => {
  try {
    const response = await deleteOrgTypeAPI(globalTypeID, globalTypeCategoryID);
    if (!response || !response.success) {
      console.log('response?.message', response?.message || 'Failed to delete globle type');
      window.showSnackbar({
        message: customErrorMsg || `Failed to delete globle type`,
        variant: 'error'
      });
    } else {
      window.showSnackbar({
        message: customSuccessMsg || `globle type deleted successfully`,
        variant: 'success'
      });
    }
    return response;
  } catch (err) {
    const errorMessage =
      err?.message || (typeof err === 'string' ? err : 'Failed to delete globle type');
    window.showSnackbar({
      message: errorMessage,
      variant: 'error'
    });
    console.log('Failed to delete globle type:', err);
    return { success: false, message: errorMessage };
  }
};
